import { useState } from 'react';
import { ACCOUNT_BLOCKED_API_ERRORS } from 'services/api.errors';
import { useLogin, useSendCodeTo } from 'hooks/api/login';
import { useNavigate } from 'hooks/routes';
import { LoginFieldNames, useLoginForm } from 'hooks/forms';
import { useGetBlockedState } from 'hooks/cache';
import { protectApiError } from 'utils/typeGuards';
import Button from 'components/Button';
import Link from 'components/Link';
import Field from 'components/Field';
import SecureIcon from 'components/SecureIcon';
import messages from './LoginForm.messages';
import styles from './LoginForm.module.css';

export default function LoginForm() {
  const { toLoginVerify, toLoginBlocked } = useNavigate();

  const blockedState = useGetBlockedState();
  if (
    protectApiError(blockedState) &&
    blockedState?.response?.data.code &&
    ACCOUNT_BLOCKED_API_ERRORS.includes(blockedState.response?.data?.code)
  ) {
    toLoginBlocked(blockedState.response?.data);
  }
  const { mutateAsync: login, isLoading } = useLogin();
  const { mutate: sendCodeTo } = useSendCodeTo();

  const [isSecured, setIsSecured] = useState(true);

  const {
    form,
    customState: { isCompleted, onBlur, onFocus },
  } = useLoginForm();

  const { toForgotPassword } = useNavigate();

  const onSubmit = form.handleSubmit(async (credentials) => {
    await login(credentials);
    await sendCodeTo(undefined, {
      onSuccess(data) {
        toLoginVerify({ phone: data?.phoneLastFourDigits });
      },
    });
  });

  const onForgotPasswordClick = () => toForgotPassword();

  return (
    <>
      <span className={styles.loginText}>{messages.title}</span>

      <form className={styles.formContainer} onSubmit={onSubmit}>
        <Field
          form={form}
          autoComplete={'off'}
          name={LoginFieldNames.userName}
          placeholder={messages.placeholder.username}
          className={styles.input}
          defaultValue={''}
          type={'text'}
          maxLength={64}
          onBlur={onBlur}
          onFocus={() => onFocus(LoginFieldNames.userName)}
        />

        <Field
          form={form}
          name={LoginFieldNames.password}
          placeholder={messages.placeholder.password}
          className={styles.input}
          defaultValue={''}
          type={isSecured ? 'password' : 'text'}
          icon={<SecureIcon changeSecuredState={() => setIsSecured(!isSecured)} />}
          onBlur={onBlur}
          autoComplete={'new-password'}
          onFocus={() => onFocus(LoginFieldNames.password)}
          maxLength={64}
        />

        <div className={styles.buttons}>
          <Button
            isLoading={isLoading}
            displayDisabledUI={!isCompleted}
            type={'submit'}
            onClick={onSubmit}
          >
            {messages.submit}
          </Button>
          <Link
            text={messages.linkForgot}
            className={styles.forgotPassword}
            onClick={onForgotPasswordClick}
          />
        </div>
      </form>
    </>
  );
}
